import { SxProps } from '@mui/material';

export const seriesColorWrapperSX = {
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'wrap',
	gap: 2,

	'& + .MuiButton-root ': {
		marginTop: -2,
	},
};

export const seriesColorWrapperSingleRowSX = {
	display: 'grid',
	gridTemplateColumns: {
		xs: 'repeat(auto-fill, minmax(calc(50% - 1rem), 1fr))',
		sm: 'repeat(auto-fill, minmax(calc(33% - 1rem), 1fr))',
		md: 'repeat(auto-fill, minmax(calc(25% - 1rem), 1fr))',
		lg: 'repeat(auto-fill, minmax(calc(20% - 1rem), 1fr))',
	},
	gap: 2,
	rowGap: 0,
	gridTemplateRows: '1fr',
	gridAutoRows: 0,
	overflow: 'hidden',
};

export const seriesColorImageWrapper45SX = {
	overflow: 'hidden',

	'& > img': {
		// 4:5 aspect ratio
		maxWidth: '125%',
		width: '125%',
		marginLeft: '-12.5%',

		paddingBottom: '.875rem',
		borderBottom: '1px solid',
		borderColor: 'primary.main',
		marginBottom: '.125rem',
	},
};

export const seriesColorSX = ({ margin = true }: { margin?: boolean }): SxProps => ({
	flex: { xs: '0 0 130px', sm: '0 0 calc(20% - (.8 * 1rem))', lg: '0 0 calc(16.66% - 1rem)' },
	display: 'flex',
	flexDirection: 'column',
	gap: 0.5,
	marginBottom: margin ? 4 : 0,

	'& img': {
		width: '100%',
		height: 'auto',
	},
});

export const seriesColorTextSX = {
	textTransform: 'uppercase',
	fontFamily: 'GT-America-Condensed, GT-America, Roboto, sans-serif',
	fontSize: '1rem',
	fontWeight: '700',
	color: 'black.main',
};
